import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUserInfo } from '@/store/slices/userInfo.js';
import Icon from '@/assets/forgotpassword/icon.svg';
import './index.less';
import { authService } from '@/api/index';
import message from '@/utils/message';

export default function ForgotPassword({ setCurrentPage }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [warningText, setWarningText] = useState('');
  const [loading, setLoading] = useState(false);

  // 用户输入email
  const handleInputEmail = (val) => {
    setEmail(val.target.value);
    setEmailCheck(false);
    setWarningText('');
    dispatch(setUserInfo({ key: 'email', value: val.target.value }));
  };
  // 跳转注册页面
  const navigateToerify = () => {
    if (!email) return;
    if (setCurrentPage) {
      setCurrentPage('verify');
      return;
    }
    navigate('/verify');
  };

  // 验证邮箱是否存在
  const handleAuthExist = async () => {
    if (!email) {
      console.log('message提醒 请输入邮箱');
      setEmailCheck(true);
      setWarningText('Please enter your email address');
      return;
    }
    if (!handleCheckEmail()) return;
    setLoading(true);
    try {
      const res = await authService.authExist({
        email,
      });
      if (res.code === 0) {
        if (res.data.exist) {
          getEmailCode();
        } else {
          console.log('message提醒 用户不存在');
          message.warning('Your email address is not registered, please register first');
          setLoading(false);
        }
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
    }
    setLoading(false);
  };
  const handleCheckEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email) && email) {
      setEmailCheck(true);
      setWarningText('Please enter the correct email address');
      return false;
    }
    if (emailCheck && email) {
      setEmailCheck(false);
      setWarningText('');
    }
    return true;
  };
  // 获取邮箱验证码
  const getEmailCode = async () => {
    try {
      const res = await authService.authEmailCode({
        email,
        usage: 1,
      });
      if (res.code === 0) {
        console.log('message提醒 验证码发送成功');
        navigateToerify();
      } else {
        console.log('message提醒 验证码发送失败');
      }
    } catch (error) {
      const err = JSON.parse(error);
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(setUserInfo({ key: 'formpage', value: 'forgotPassword' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 添加回车键盘监听
  useEffect(() => {
    const handleEnterPress = (e) => {
      if (e.key === 'Enter') {
        handleAuthExist();
      }
    };

    document.addEventListener('keydown', handleEnterPress);

    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
  return (
    <div className="forgotpasswordBox">
      <img src={Icon} className="iocnlogo" alt="" />
      <div className="text">Forgot your password?</div>
      <div className="text2">
        Enter your email address and we will send you <br />
        instructions to reset your password.
      </div>
      <div className="warning_text">{emailCheck && warningText}</div>
      <input
        type="text"
        placeholder="Email Address"
        onInput={handleInputEmail}
        onBlur={handleCheckEmail}
        className={`input input-bordered email_ipt ${emailCheck ? 'input-error' : ''}`}
      />

      {loading ? (
        <button className="btn btn-primary continue_btn">
          <span className="loading loading-spinner loading-md"></span>
        </button>
      ) : (
        <button className="btn btn-primary continue_btn" onClick={handleAuthExist}>
          Continue
        </button>
      )}
    </div>
  );
}
